'use client';

import { Tag } from '@components/templates/my-jobs/Card/partials/Tag';
import { ApiCompanyJobDetail } from '@type/v1-api-types';
import { useTranslation } from 'next-i18next';


const COMPANY_JOB_CANDIDATES_TAGS: {
  label: string;
  href: (jobSlug: string) => string;
  countKey?: string;
  className: string;
}[] = [
  // The "Recomandati din DB" tag is gone: it pointed at
  // `/applicants/input-flow`, and the input-flow board is deprecated — the v2
  // pipeline replaced it at 100% in prod on 2026-09-16.
  {
    label: 'my-jobs.card.tags.likes',
    countKey: 'numberOfLikes',
    href: (jobSlug) => `/job/${jobSlug}/users-who-favorite-my-job`,
    className: 'hover:bg-[#F0F2F4] dark:hover:text-dark',
  },
];

interface CandidatesTagsProps {
  job: ApiCompanyJobDetail;
}

export const CandidatesTags = (props: CandidatesTagsProps) => {
  // Destructure props
  const { job } = props;
  const totalViews = job?.totalViews || 0;

  // Translation
  const { t } = useTranslation('common');
  const pillClass = 'border flex gap-1 rounded-full bg-surface text-sm px-4 py-1.5';

  return (
    <div className="mt-8 border-t border-input pt-8">
      <h3 className="mb-5 text-lg font-bold">{t('job.detail.company.candidates.title')}</h3>
      <div className="flex flex-wrap gap-2">
        {COMPANY_JOB_CANDIDATES_TAGS.map((tag) => (
          <Tag
            key={tag.label}
            {...tag}
            label={t(tag.label)}
            href={tag.href(job.slug)}
            count={tag.countKey ? job.applicationStats?.[tag.countKey] : undefined}
          />
        ))}

        {totalViews > 0 && (
          <span className={pillClass}>
            {t('job.viewers.page.total_views', { totalViews })}
          </span>
        )}
      </div>
    </div>
  );
};
